import { IncomingInvoiceApprovalsTable } from "@/components/incoming-invoices/approvals-table";
import { useIncomingInvoice } from "@/hooks/use-incoming-invoice";
import type { IncomingInvoicePanelBaseProps } from "../../shared";

export function IncomingInvoiceApprovals({ incomingInvoiceId }: IncomingInvoicePanelBaseProps) {
	/** Query */
	const { incomingInvoice, isLoading, queryKey, refetch } = useIncomingInvoice(incomingInvoiceId);

	/** Render */
	return (
		<IncomingInvoiceApprovalsTable
			incomingInvoice={incomingInvoice}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
		/>
	);
}
